




export default function LoadMoreButton({className,...props}) {

    return (
        <div className={`${className} flex-1 gap-3 cursor-pointer mb-4 lg:mb-8 flex justify-center items-center`}
             {...props}
        >
            <p className={"bg-tertiary-150 h-10 w-10 rounded-full text-center text-2xl text-tertiary-900"}>
                +
            </p>
            <p className={"text-lg font-bold "}>
                Load More
            </p>
        </div>

    )
}
